module.exports = "\n<component :is=\"currentView\" keep-alive></component>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Router.vue
// module id = 112
// module chunks = 0